if (!customElements.get('sanne-product-videos')) {
  customElements.define('sanne-product-videos', class extends HTMLElement {
    connectedCallback() {
      requestAnimationFrame(() => this.initialize());
    }
    initialize() {
      this.querySelectorAll('.spv__card').forEach(card => {
        const video = card.querySelector('video');
        const button = card.querySelector('.spv__play');
        const error = card.querySelector('.spv__error');
        if (!video || !button || card.dataset.initialized) return;
        card.dataset.initialized = 'true';
        video.controls = false;
        button.hidden = false;
        button.addEventListener('click', () => {
          error.hidden = true;
          video.controls = true;
          video.play().catch(() => {
            button.hidden = false;
            error.hidden = false;
          });
        });
        video.addEventListener('play', () => {
          this.querySelectorAll('video').forEach(other => {
            if (other !== video) other.pause();
          });
          error.hidden = true;
          button.hidden = true;
        });
        video.addEventListener('pause', () => { button.hidden = false; });
        video.addEventListener('ended', () => { button.hidden = false; });
      });
    }
    disconnectedCallback() {
      this.querySelectorAll('video').forEach(video => video.pause());
    }
  });
}
